//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parse } from "node-html-parser";
import { sanitize } from "string-sanitizer";

export default {
  data() {
    return {
      sections: [{ title: null, id: "section-default", content: "" }],
      showAll: false,
      showMobileContents: false,
    };
  },
  props: {
    data: {
      required: true,
    },
    cta: {
      required: true,
    },
  },
  computed: {
    moreorless() {
      if (this.showAll) return "less";
      else return "more";
    },

    activeRoute() {
      return this.$route.hash.slice(1);
    },
  },
  methods: {
    parseContent() {
      let parsedGuide = parse(this.data.body);
      let nodes = parsedGuide.childNodes;
      let sections = [{ ...this.sections[0] }];
      let currentSection = sections[0];
      nodes.forEach((node, i) => {
        if (!currentSection.content) currentSection.content = "";
        if (node.rawTagName == "h4") {
          sections.push({
            title: node.text,
            id: sanitize.addDash(node.text).toLowerCase(),
            content: "",
          });
          currentSection = sections[sections.length - 1];
          node.id = "section_" + i;
        } else if (
          node.rawTagName == "p" ||
          node.rawTagName == "ul" ||
          node.rawTagName == "h5" ||
          node.rawTagName == "table" ||
          node.rawTagName == "div"
        ) {
          currentSection.content += node.outerHTML;
        }
      });
      return (this.sections = sections);
    },
  },
  mounted() {
    this.parseContent();

    if (this.$route.hash) {
      this.showAll = true;
    }
  },
};
